import { Button, Grid, Typography } from "@mui/material";
import React from "react";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function ApprovePayment({
  selectedRowId,
  onClose,
  showSnackbar,
  handleApprovePayment
}) {
  const userId = localStorage.getItem("userId");
  const handleCancel = () => {
    onClose();
  };

 const handleSubmit =()=>{
  handleApprovePayment()
 }

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h3">
            Are you sure to approve this payment request?{" "}
          </Typography>
        </Grid>
        <Grid item xs={12} container gap={1} justifyContent="end">
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={handleCancel}
          >
            {" "}
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleSubmit}
          >
            {" "}
            Approve
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
